module.exports = __webpack_public_path__ + "img/LTC.e33d5d68.svg";